{
  "app": {
    "title": "SMS 库存管理",
    "subtitle": "供应商 × 物流 × CoEldery 85",
    "language": "语言"
  },
  "nav": {
    "dashboard": "仪表板",
    "master": "主档",
    "settings": "设置",
    "intake": "入库",
    "build": "版本",
    "pending": "待收货",
    "myShipments": "我的发货单",
    "inventory": "库存",
    "movements": "账本",
    "outbound": "出库",
    "weeklyFee": "仓租",
    "reports": "周报",
    "todo": "未完成事项"
  },
  "common": {
    "loading": "载入中…",
    "loadFailed": "载入失败，请重试",
    "save": "保存",
    "saving": "保存中…",
    "saved": "已保存 ✓",
    "add": "新增",
    "adding": "新增中…",
    "refresh": "重新载入",
    "optional": "（选填）"
  },
  "setup": {
    "title": "首次登录：设置 Email ＋ 新密码",
    "intro": "你好 {{name}}！这是第一次登录 —— 请设置你的 email 和新密码，之后用 email 登录。",
    "email": "Email",
    "emailHint": "之后用这个 email ＋ 密码登录（全系统唯一）。",
    "currentPassword": "现有密码（预设）",
    "currentHint": "就是你第一次登录用的预设密码。",
    "newPassword": "新密码",
    "confirm": "再输入新密码",
    "policy": "最少 8 个字符；不可以与预设密码相同。",
    "mismatch": "两次输入的新密码不一样",
    "submit": "设置完成，开始使用",
    "titleChange": "修改 Email／密码",
    "introChange": "{{name}}，你可以在这里修改登录 email 和密码（需要输入现有密码）。",
    "currentPasswordChange": "现时密码",
    "newPasswordChange": "新密码（不想改就照填现时密码）",
    "submitChange": "保存",
    "currentEmail": "现时 email：{{email}}"
  },
  "po": {
    "intro": "向供应商下单：可以按「安全库存」建议补货，下单后供应商会确认订单（可改数量＋填 ETA）。",
    "supplierIntro": "CoEldery 85 向你下的采购单会显示在这里：可以确认订单（改数量＋填 ETA）或出货。",
    "shortageTitle": "低于安全库存（建议补货）",
    "shortageHint": "现时在仓（＝入 − 出）低于你设定的安全库存就会列出；安全库存在「主档 → 货品」设定。",
    "shortageEmpty": "没有货品低于安全库存 ✓",
    "suggest": "建议补 {{n}} 箱",
    "newTitle": "开新采购单",
    "supplier": "供应商",
    "pick": "请选择",
    "requestedAt": "要求到货日（期望）",
    "requestedAtHint": "供应商确认时会填实际 ETA；这是你的期望，不一定相同。",
    "item": "货品",
    "cartons": "箱数",
    "addLine": "加一行",
    "removeLine": "减一行",
    "note": "备注",
    "submit": "下单（草稿）",
    "created": "已开单 {{no}} ✓（记得按「送出」通知供应商）",
    "listTitle": "采购单",
    "empty": "还没有采购单。",
    "emptySupplier": "暂时没有 CoEldery 85 的采购单。",
    "eta": "预计到货（ETA）",
    "onHand": "现时在仓",
    "safeLevel": "安全库存",
    "ackHint": "⚠️ 只可以减少（不可以加单）—— 改了数量就一定要填原因。",
    "ackNote": "改动原因（改了数量必填）",
    "ordered": "下单（箱）",
    "acked": "确认（箱）",
    "close": "收起",
    "linkedIntake": "已自动开发货单 {{no}}（状态 {{status}}）—— 物流会按原本流程收货对账。",
    "status": {
      "draft": "草稿",
      "sent": "已送出",
      "ack": "已确认",
      "shipped": "已出货",
      "received": "已收货",
      "closed": "已完成",
      "cancelled": "已取消"
    },
    "act": {
      "send": "送出",
      "ack": "确认订单",
      "ship": "出货",
      "receive": "已收货",
      "close": "完单",
      "cancel": "取消"
    },
    "ask": {
      "cancel": "确定取消这张采购单？"
    },
    "done": {
      "send": "已送出 ✓",
      "ack": "已确认订单 ✓",
      "ship": "已出货（已自动开发货单）✓",
      "receive": "已收货 ✓",
      "close": "已完单 ✓",
      "cancel": "已取消 ✓"
    }
  },
  "tab": {
    "aria": "底部导航",
    "menu": "菜单",
    "language": "语言",
    "newVersion": "有新版本，请重新载入",
    "password": "修改密码",
    "account": "修改 Email／密码",
    "todo": "未完成事项",
    "reports": "周报／导出",
    "master": "主档（供应商／货品）",
    "ledger": "账本",
    "settings": "设置（费率／目的地…）",
    "me": "我的资料",
    "orders": "订单",
    "shipment": "出货",
    "stock": "库存",
    "incoming": "到货",
    "pickup": "出货指示",
    "fees": "仓租",
    "overview": "总览",
    "purchase": "采购",
    "outbound": "出库",
    "disposition": "货去向"
  },
  "me": {
    "title": "我的资料",
    "intro": "你公司的基本资料（改完立即生效）。",
    "code": "供应商代号",
    "codeHint": "⚠️ 代号是身份（单号／对账都用它）—— 要改请找 CoEldery 85 职员。",
    "name": "公司名称",
    "contactName": "联系人",
    "contactPhone": "联系电话",
    "waNumber": "WhatsApp 号码",
    "waHint": "国际格式（例 85291234567）—— 出库通知会发到该号码所属的物流群组（P1-8）。",
    "saved": "已保存 ✓",
    "attrsTitle": "自定义字段",
    "attrsHint": "将来新增的字段会显示在这里（不需要改数据库；由管理员设置）。",
    "attrsEmpty": "暂时没有自定义字段。"
  },
  "orders": {
    "title": "订单",
    "intro": "CoEldery 85 向你下的采购单会显示在这里。",
    "buildingTitle": "⏳ 施工中（P1.5-B）",
    "buildingBody": "采购单功能正在开发：之后你会在这里看到单号、数量、到货日期，并且可以「确认接单／改数量／填 ETA」。现阶段请用「出货」自己开发货单。",
    "gotoShipments": "去「出货」（开发货单）→"
  },
  "purchase": {
    "title": "采购",
    "intro": "向供应商下单（按安全库存建议数量）。",
    "buildingTitle": "⏳ 施工中（P1.5-B）",
    "buildingBody": "采购单功能正在开发：之后你可以在这里选货品、按安全库存建议补货量下单，供应商确认后才出货。",
    "gotoOutbound": "去「出库」（向物流下单）→"
  },
  "myItems": {
    "title": "我的货品",
    "hint": "你的货品清单（cbm 由箱尺寸自动计算）。开新货品之后，就可以在「出货」开单。",
    "add": "＋ 新增货品",
    "hideAdd": "收起新增表单",
    "empty": "还没有货品 —— 按上面「＋ 新增货品」加第一件。",
    "unitsPerCarton": "每箱件数",
    "cartonSize": "箱尺寸（长×宽×高）",
    "cbmPerCarton": "每箱 cbm",
    "safeLevel": "安全库存（箱）",
    "inactive": "已停用"
  },
  "pwd": {
    "title": "修改密码",
    "intro": "修改后，你其他设备的登录会立即失效（这台设备不会）。",
    "current": "旧密码",
    "next": "新密码",
    "confirm": "再输入新密码",
    "policy": "最少 8 个字符；不接受常见弱密码。",
    "mismatch": "两次输入的新密码不一样",
    "submit": "修改密码",
    "done": "已修改密码 ✓",
    "back": "返回 →"
  },
  "stock": {
    "formulaTitle": "库存算法：入 − 出 ＝ 现时",
    "formulaHint": "入库（进入仓库）减出库（离开仓库）＝ 现时仓库量。三个角色读同一本账本，所以数字必然一致。",
    "scoped": "你只会看到自己的货（伙伴数据隔离）。",
    "in": "入库",
    "out": "出库",
    "current": "现时仓库量",
    "ok": "账本自洽 ✓",
    "mismatch": "⚠️ 公式与余额不一致（请通知职员检查）",
    "empty": "还没有货品记录。",
    "sku": "货品",
    "inCartons": "入（箱）",
    "inCbm": "入（cbm）",
    "outCartons": "出（箱）",
    "outCbm": "出（cbm）",
    "currentCartons": "现时（箱）",
    "currentCbm": "现时（cbm）",
    "balanceCbm": "余额核对（cbm）"
  },
  "home": {
    "healthTitle": "系统状态",
    "checking": "检查中…",
    "dbUp": "数据库连接正常",
    "dbUnbound": "数据库未绑定（本地开发请运行 npm run dev:cf）",
    "apiDown": "API 无响应"
  },
  "dash": {
    "title": "仪表板",
    "intro": "今天要处理的事（按你的角色显示；没显示的代表与你无关）",
    "scoped": "你只会看到自己的货和单（伙伴数据隔离）",
    "pendingIntake": "待收货（批）",
    "pendingOutbound": "待出库（单）",
    "weekCbm": "本周 cbm（计费基础）",
    "weekCbmHint": "期初制：{{week}} 的在仓量",
    "unconfirmedFees": "待确认仓租（周）",
    "unsettledEvents": "⚠️ 未结算场次",
    "unsettledEventsHint": "直销场已交收但未做场后结算",
    "missingChop": "⚠️ 缺交收证据",
    "missingChopHint": "送货已交收但还没有客户盖章／签名照片",
    "onSiteCbm": "在场 cbm",
    "pendingTitle": "未完成事项",
    "seeAllPending": "查看全部未完成事项 →"
  },
  "pending": {
    "title": "未完成事项",
    "intro": "需要人跟进的清单：未结算场次／缺交收证据／在场库存（目标 ＝ 没有一张出库单失踪）",
    "summary": "未结算 {{events}} 场 · 缺证据 {{chop}} 单 · 在场 {{cbm}} cbm",
    "unsettledTitle": "未结算场次",
    "unsettledHint": "直销场（direct_sale）已交收但未做场后结算 → 账未出齐",
    "unsettledEmpty": "没有未结算场次 ✓",
    "missingChopTitle": "缺交收证据",
    "missingChopHint": "送货（delivery）已交收但还没有「客户盖章／签名」照片（可以后补上传）",
    "missingChopEmpty": "全部送货单都有交收证据 ✓",
    "missingChopBadge": "⚠️ 缺盖章照片",
    "onSiteTitle": "在场库存",
    "onSiteHint": "还留在场地（roadshow）未搬走的货",
    "onSiteEmpty": "没有货留在场地 ✓",
    "cartons": "箱",
    "units": "件",
    "cbm": "cbm",
    "skus": "款",
    "deliveredAt": "交收",
    "openOrder": "去处理",
    "reload": "重新载入"
  },
  "report": {
    "title": "周报／导出",
    "intro": "仓租明细 ＋ 出入库摘要（数字直接由仓租模块和账本出，不会另算一套）",
    "week": "周（星期一）",
    "prevWeek": "上一周",
    "nextWeek": "下一周",
    "thisWeek": "本周",
    "exportXlsx": "导出 Excel（.xlsx）",
    "exportCsv": "导出 CSV",
    "exported": "已导出 {{name}}",
    "sheetFee": "仓租明细",
    "sheetLedger": "出入库摘要",
    "sheetBatches": "入库批次",
    "sheetPending": "未完成事项",
    "feeTitle": "仓租明细",
    "feeHint": "期初 cbm × 储存费率 ＋ 该周入库手续费（期初制；周中出入库不影响该周）",
    "ledgerTitle": "出入库摘要",
    "ledgerHint": "账本（stock_movements）按移动类别汇总 —— 唯一真相源",
    "batchTitle": "入库批次",
    "batchHint": "该周收货的批次（手续费归属周）",
    "type": "类别",
    "count": "笔数",
    "cartons": "箱",
    "units": "件",
    "cbm": "cbm",
    "status": "状态",
    "batchNo": "发货单号",
    "supplier": "供应商",
    "receivedDate": "收货日",
    "receivedCbm": "实收 cbm",
    "handlingFee": "手续费",
    "item": "项目",
    "value": "数量",
    "notGenerated": "未产生",
    "generatedAt": "产生于",
    "matchesOk": "（与即时重算一致 ✓）",
    "matchesBad": "（⚠️ 与即时重算不一致）",
    "issues": "⚠️ ",
    "noLedger": "本周账本没有任何移动",
    "noBatch": "本周没有入库批次",
    "pendingLine": "未完成事项：未结算 {{events}} 场 · 缺交收证据 {{chop}} 单",
    "gotoFees": "去产生／确认仓租 →"
  },
  "login": {
    "title": "登录",
    "username": "账号",
    "identifier": "Email 或 账号",
    "identifierHint": "第一次登录用账号（例 S0001）；设置完 email 之后，用 email 登录。",
    "password": "密码",
    "submit": "登录",
    "submitting": "登录中…",
    "failed": "登录失败，请重试",
    "logout": "退出登录",
    "welcome": "你好，{{name}}"
  },
  "role": {
    "supplier": "供应商",
    "logistics": "物流伙伴",
    "staff": "CoEldery 85 职员",
    "admin": "管理员"
  },
  "master": {
    "title": "主档：供应商／货品",
    "suppliersTitle": "供应商（货主）",
    "itemsTitle": "货品（SKU）",
    "code": "供应商代号",
    "name": "名称",
    "contactName": "联系人",
    "contactPhone": "联系电话",
    "waNumber": "WhatsApp 号码",
    "addSupplier": "新增供应商",
    "supplierCreated": "已新增供应商 ✓",
    "supplier": "供应商",
    "filterSupplier": "筛选供应商",
    "allSuppliers": "全部供应商",
    "itemName": "货品名称",
    "barcode": "条码",
    "unitsPerCarton": "每箱件数",
    "cartonDims": "箱尺寸",
    "cartonL": "箱长（cm）",
    "cartonW": "箱宽（cm）",
    "cartonH": "箱高（cm）",
    "cbmOverride": "cbm 覆写",
    "weightKg": "每箱重量（kg）",
    "cbm": "每箱 cbm",
    "cbmPerUnit": "每件 cbm",
    "addItem": "新增货品",
    "pickSupplierFirst": "⚠️ 请先选择供应商（按「新增货品」没有反应就是因为还没选）",
    "itemCreated": "已新增货品 ✓",
    "photo": "照片",
    "uploadPhoto": "上传照片",
    "photoUploading": "上传中…",
    "photoUploaded": "照片已上传 ✓",
    "noPhoto": "暂无照片",
    "emptySuppliersTitle": "暂无供应商",
    "emptySuppliersBody": "先新增一个货主，之后就可以入货品。",
    "emptyItemsTitle": "暂无货品",
    "emptyItemsBody": "选一个供应商，再入第一件货。",
    "hintCbm": "每箱 cbm 由尺寸自动计算（长×宽×高÷1,000,000），仓租就是用这个数。",
    "hintBarcode": "一个条码一件货（全系统唯一）。",
    "hintOverride": "只有尺寸不准时才填；填了就以这个为准。"
  },
  "settings": {
    "title": "设置（后台）",
    "note": "费率／结算日／WhatsApp 设置一律在这里改 —— 代码不会写死。",
    "save": "保存设置",
    "saved": "已保存 ✓",
    "saveFailed": "保存失败",
    "feeHandlingPerCbm": "入库手续费（每 cbm，HK$）",
    "feeStoragePerCbmWeek": "仓租（每 cbm 每周，HK$）",
    "settlementWeekday": "每周结算日",
    "feeFirstStorageFrom": "起租日（首批货到仓日）",
    "hintFirstStorageFrom": "空白 = 无特例。设定后：该日所属结算周期的期初「含当日」（例：2026-09-23 到仓 → 9/23–9/29 该周就收 61.4 × 仓租费率）。",
    "waTemplateOutbound": "出库通知 template 名",
    "waTemplatePicked": "已执货通知 template 名",
    "waTemplateLang": "template 语言",
    "waMaxItemsInMessage": "消息最多列多少项货品",
    "waRecipients": "WhatsApp 收讯人（电话）",
    "waRecipientsStaff": "下单人 WhatsApp 收讯人（电话）",
    "outboundOrderNoPrefix": "出库单编号前缀",
    "outboundDeliveryCodePrefix": "送货码前缀",
    "intakeBatchNoPrefix": "入库批次前缀",
    "weekday1": "星期一",
    "weekday2": "星期二",
    "weekday3": "星期三",
    "weekday4": "星期四",
    "weekday5": "星期五",
    "weekday6": "星期六",
    "weekday7": "星期日",
    "hintRecipients": "只填数字含国码（例 85291234567）；多个用逗号分隔。",
    "hintRecipientsStaff": "执货完成后通知下单人（职员）；要先用已批准的已执货 template；只填数字含国码。",
    "hintTemplate": "要同 Meta 已批准的 template 名一模一样。",
    "hintTemplatePicked": "执货完成通知用的 template（例 sms_outbound_picked）；未批准之前不会发送。",
    "appBaseUrl": "系统对外网址（WhatsApp 链接用）",
    "hintBaseUrl": "例 https://sms.85ai.app —— WhatsApp 通知的「开启系统」按钮就是用这个；⚠️ 不要用 *.pages.dev（每次部署会变）"
  },
  "order": {
    "linkTitle": "出库指示 {{orderNo}}",
    "linkBody": "你从 WhatsApp 通知点进来。下面会自动找回这张出库单；要执货就按「去执货清单」。",
    "lookingUp": "正在查找这张出库单…",
    "notFound": "找不到 {{orderNo}} 这张单（可能未建立，或者单号写错）。",
    "noAccess": "你的帐号没有出库权限（出库流程只限物流／职员／管理员）。",
    "openOrder": "查看出库单",
    "startPick": "去执货清单",
    "goHome": "去主页"
  },
  "intake": {
    "titleSupplier": "我的发货单",
    "titleLogistics": "入库／待收货",
    "newBatch": "新增发货单",
    "batchNo": "批次号",
    "supplier": "供应商",
    "declaredShipDate": "送货日期",
    "receivedDate": "收货日（起算日）",
    "status": "状态",
    "declaredCbm": "申报 cbm",
    "receivedCbm": "入库 cbm",
    "handlingFee": "入库手续费",
    "note": "备注",
    "items": "货品",
    "item": "货品",
    "pickItem": "选择货品",
    "declaredCartons": "申报箱数",
    "receivedCartons": "实收箱数",
    "damagedCartons": "损坏箱数",
    "productionDate": "生产日期",
    "expiryDate": "到期日",
    "addLine": "加一项货",
    "removeLine": "删除",
    "create": "建立发货单",
    "created": "已建立发货单 ✓",
    "needLine": "至少要有一行（每行要选货品 ＋ 填箱数）",
    "verify": "确认收货（即时入账）",
    "verifying": "入账中…",
    "verified": "已收货入账 ✓",
    "verifyHint": "实收与申报不同 → 一定要填原因；有损坏 → 一定要上传箱照。",
    "diffReason": "差异原因",
    "damagePhoto": "损坏箱照",
    "uploadDamage": "上传箱照",
    "uploading": "上传中…",
    "uploaded": "已上传 ✓",
    "damageNeedPhoto": "有损坏就要上传箱照（规则要求）",
    "statusDeclared": "已申报（未收货）",
    "statusReceived": "已收货",
    "statusVerified": "已对账",
    "statusDiscrepancy": "有差异",
    "statusCancelled": "已取消",
    "filterStatus": "筛选状态",
    "allStatus": "全部状态",
    "emptyTitle": "暂无发货单",
    "emptyBody": "供应商建立第一张发货单，物流就会见到。",
    "emptyPendingTitle": "暂时没有待收货",
    "emptyPendingBody": "有供应商申报之后，这里会出现。",
    "open": "查看",
    "back": "返回列表",
    "detailTitle": "发货单详情",
    "readOnly": "只有物流／职员／管理员可以做收货对账。",
    "damagedNote": "损坏货入仓内损坏区：照计仓租、但不会出库。",
    "addItemFirst": "先加一件货品",
    "itemsTitle": "货品（逐行）",
    "lineNoItem": "第 {{n}} 行：没选货品 —— 要在「货品」下拉选一件（没得选就先按「新增货品」）",
    "lineNoCartons": "第 {{n}} 行：箱数没填（要 1 或以上）",
    "itemAddedLine": "已自动把「{{name}}」加入发货单 —— 请填箱数",
    "addItemToggle": "＋ 新增货品"
  },
  "loc": {
    "warehouse": "物流仓",
    "damaged": "损坏区",
    "office": "办公室",
    "supplier": "供应商（未出货）",
    "writtenOff": "已注销"
  },
  "inv": {
    "title": "库存余额",
    "intro": "显示每个位置现在有多少货。cbm 是计费基础；损坏货未离开仓库一样照计租。",
    "rowsTitle": "各位置余额",
    "mirrorHidden": "已收起 {{n}} 行「账簿对冲」（负数 = 账簿另一边，不是实际存量）",
    "showMirror": "显示账簿对冲行",
    "mirrorHint": "⭐ 为何有负数：每次入库只写一笔移动「供应商 → 物流仓」，而位置余额是逐个位置的净数 → 来源位置（例：供应商未出货）一定是等量负数。全部位置加起来 = 0 属正常，也不影响仓租（计租只有物流仓 + 损坏区）。",
    "filterLocation": "位置",
    "allLocations": "全部位置",
    "filterSupplier": "供应商",
    "allSuppliers": "全部供应商",
    "includeEmpty": "连已清空（0 箱）的位置也显示",
    "summaryWarehouse": "仓内 cbm（计租基础）",
    "summaryWarehouseHint": "＝ 物流仓 ＋ 损坏区（decisions/003）",
    "summaryDamaged": "其中损坏区 cbm",
    "summaryCounts": "货品 ／ 批次",
    "summaryCountsHint": "独立货品数 ／ 货品・批次组合数",
    "byLocationTitle": "各位置明细（负数 ＝ 已离开该位置，正常）",
    "invariantBad": "⚠️ 账本不自洽：全部位置 cbm 总和 ＝ {{net}}（应该 ≈ 0）→ 请即刻查账本",
    "scopedNotice": "你只会见到自己的货（供应商范围，后端把关）。",
    "emptyTitle": "暂时没有库存",
    "emptyBody": "物流做完收货对数之后，余额会即时出现在这里。",
    "batch": "批次",
    "cartons": "箱",
    "units": "件"
  },
  "mov": {
    "title": "库存账本",
    "intro": "账本是唯一真相源，只可以追加（要更正 ＝ 另开一条「更正」，不准改旧记录）。",
    "filterType": "类型",
    "allTypes": "全部类型",
    "from": "从",
    "to": "至",
    "typeIn": "入库",
    "typeOut": "出库",
    "typeSale": "售出",
    "typeTransfer": "调拨",
    "typeAdjust": "更正",
    "actor": "经手人",
    "ref": "来源",
    "emptyTitle": "暂时没有账目",
    "emptyBody": "入库对数之后，第一条账目就会出现。",
    "prev": "上一页",
    "next": "下一页",
    "pageInfo": "第 {{page}}／{{last}} 页（共 {{total}} 条）"
  },
  "out": {
    "title": "出库单",
    "newOrder": "新增出库单",
    "newHint": "直销场出货选「直销」；送货／样品选「送货」。cbm 一律由系统计算。",
    "create": "建立出库单",
    "back": "返回列表",
    "backToOrder": "返回出库单",
    "emptyTitle": "暂无出库单",
    "emptyBody": "职员建立第一张出库单后，这里就会出现。",
    "filterStatus": "筛选状态",
    "filterKind": "筛选类型",
    "allStatus": "全部状态",
    "allKinds": "全部类型",
    "kind": "出库类型",
    "kindDirectSale": "直销场",
    "kindDelivery": "送货",
    "destination": "去向",
    "deliveryMode": "取货方式",
    "modeSelfPickup": "自取",
    "modeLogistics": "物流运送",
    "pickupAt": "取货时间",
    "hintPickupAt": "WhatsApp 通知会写明这个时间；送货单请填实际送达时段。",
    "consignee": "收货方",
    "address": "地址",
    "note": "备注",
    "lines": "出库货品",
    "item": "货品",
    "itemCount": "货品项数",
    "pickItem": "选择货品",
    "batch": "批次",
    "batchAuto": "自动（先到先出）",
    "cartons": "箱数",
    "cbm": "cbm",
    "warehouseAvailable": "仓内可用 {{n}} 箱",
    "addLine": "加一项货",
    "removeLine": "删除",
    "hintCartons": "出库一律整箱；不选批次 = 系统按最早到期自动分派（同一件货跨批次会自动拆行）；仓内不够货的话开单会被拒（要先入库）。",
    "noItems": "主档还没有货品，请先去主档新增。",
    "needDestination": "请选择去向",
    "needPickupAt": "请填写取货时间",
    "needConsignee": "请填写收货方",
    "needLine": "至少要有一项货",
    "required": "必填",
    "detailTitle": "出库单详情",
    "deliveryCode": "送货码",
    "waSentAt": "通知发出时间",
    "pickedAt": "执货日",
    "toLoc": "执货去向",
    "outboundCbm": "出库 cbm",
    "summary": "执货摘要",
    "declaredCartons": "申报箱数",
    "picked": "已执箱数",
    "pickedCartons": "实际执到（箱）",
    "pendingLines": "未执行数",
    "shortfall": "执少箱数",
    "pickDiscrepancy": "执货差异",
    "next": "下一步",
    "statusDraft": "草稿（未通知）",
    "statusSent": "已通知（等执货）",
    "statusAcknowledged": "已执货（等交收）",
    "statusDelivered": "已交收",
    "statusReconciled": "已结算（待完单）",
    "statusClosed": "已完成",
    "statusCancelled": "已取消",
    "sendTitle": "WhatsApp 出库通知",
    "sendHint": "发通知之后，对方 WhatsApp 会收到取货时间 ＋「开启系统」按钮；发出 ＝ 状态转「已通知」，之后才可执货。",
    "send": "发出通知",
    "sending": "发送中…",
    "preview": "预览（不发送）",
    "previewResult": "预览结果（未发送）",
    "template": "模板",
    "lang": "语言",
    "deepLink": "链接",
    "recipients": "收讯人（遮蔽）",
    "sendOk": "已发出通知 ✓",
    "sendFailed": "发送失败：状态仍是草稿，可以修改后再发",
    "needStaffToSend": "发通知只有职员／管理员可以做。",
    "goPick": "去执货",
    "picklistTitle": "执货清单",
    "pickOnlyWhenSent": "要「已通知」之后才可执货（通知未发 ＝ 对方不知道有货）。",
    "pickDone": "✓ 已执货 —— 客户来取货／送达目的地时，按下面那个按钮完成交收（日期会记下今天）。",
    "pickClosed": "这张单已经交收（下一步由 CoEldery 85 职员处理）。",
    "awaitingHandover": "⏳ 待交收",
    "goHandOver": "去交收",
    "confirmPick": "确认执货（即时记账）",
    "pickInvalid": "实际执到箱数要是 0 或以上的整数",
    "pickTooMany": "不可以执多过申报（{{n}} 箱）；要多出 ＝ 另开一张新单",
    "pickNeedReason": "执少一定要填原因",
    "pickNote": "原因／备注",
    "pickNoteRequired": "原因（执少必填）",
    "cancel": "取消出库单",
    "cancelConfirm": "确定取消出库单 {{orderNo}}？（取消之后不可以再执货）",
    "cancelledHint": "这张单已取消。",
    "needsReconciliation": "直销场交收完还要场后结算（卖出／剩货／损坏 ＋ 剩货去向）才可完单。",
    "deliverTitle": "交收一键",
    "deliverHintDelivery": "送货／样品：按一下即完单（日期、账目、通知由系统处理）。",
    "deliverHintSale": "直销场：按一下即「已交收」；之后由 CoEldery 85 职员做场后结算。",
    "deliver": "确认交收",
    "collectNow": "已收货",
    "deliverNow": "已送货",
    "deliverSale": "已交收（场务）",
    "deliverOneTapAsk": "确定「{{what}}」？（交收日期 = 今天；之后不可再改）",
    "deliverNoteOptional": "＋加备注（可选）",
    "delivered": "已交收 ✓",
    "deliveredAt": "交收日",
    "deliverNote": "交收备注",
    "needStaffToReconcile": "这张单交收之后由 CoEldery 85 职员做场后结算／完单（仓库已完成）。",
    "printDeliveryNote": "打印送货单（PDF）",
    "printDeliveryNoteHint": "送货单由系统生成（含送货码），开新分页后用浏览器打印／另存 PDF。收货方签名／盖章后，拍照上传作为交收证据。",
    "evidence": "交收证据（送货单连章／签名）",
    "missingEvidence": "⚠️ 缺交收证据：还没上传「有客户印章／签名嘅送货单」照片 —— 未算完成。",
    "missingEvidenceShort": "缺交收证据",
    "evidenceOk": "✓ 已有交收证据（客户印章／签名照片）。",
    "evidenceNotYet": "交收之后补上「有客户印章／签名嘅送货单」照片（不需要当场拍）。",
    "evidenceSupplierNoAccess": "交收证据只有物流／职员／管理员看得到。",
    "chopPhoto": "送货单（连章签名）照片",
    "uploadChop": "上传送货单照片（后补）",
    "uploadChopHint": "拍「有客户印章／签名」嘅送货单整张（JPEG／PNG／WebP，≤5 MB）。⚠️ 证据只可以新增，不可以删除或覆盖。",
    "uploadFailed": "上传失败",
    "uploaded": "已上传 ✓",
    "copied": "已复制 ✓",
    "copyLink": "复制链接",
    "copyFailed": "复制失败，请手动复制"
  },
  "recon": {
    "title": "场后结算",
    "intro": "直销场交收完成后要逐项对数：卖出 ＋ 剩货 ＋ 损坏 必须等于实际拣货量（箱和散件都要），对得上才准确认入账。",
    "backToOrder": "返回出库单",
    "goReconcile": "去结算",
    "goClose": "去完单",
    "savedLines": "已结算项目",
    "savedDraft": "已存草稿（未入账）✓",
    "confirmed": "已确认入账 ✓（状态转为「已结算」）",
    "confirmedAt": "确认时间",
    "onlyDirectSale": "只有直销场单需要场后结算（送货单送达即完单）。",
    "needStaffToClose": "完单只有职员／管理员可以做。",
    "closedHint": "该单已完成（账已入，不能修改）。",
    "closeOrder": "完单",
    "closeAsk": "确定完单 {{orderNo}}？（完单之后不能修改结算）",
    "closedOk": "已完单 ✓",
    "toLoc": "落点",
    "sold": "卖出",
    "leftover": "剩货",
    "damaged": "损坏",
    "cartons": "箱",
    "units": "件",
    "outCartons": "出库（实际拣货）",
    "declaredCartons": "申报",
    "unitsPerCarton": "每箱件数",
    "outUnits": "出库 {{n}} 件",
    "balanced": "对得上 ✓",
    "unbalanced": "对不上（差 {{n}} 件）",
    "balancedOk": "全部项目对得上，可以确认入账。",
    "unbalancedLines": "还有 {{n}} 行对不上（或未填齐）—— 不准确认。",
    "balanceHint": "铁律：卖出 ＋ 剩货 ＋ 损坏 ＝ 出库量（箱 × 每箱件数 ＋ 件）。损坏要填原因；退回物流仓只准未开箱整箱。",
    "disposition": "剩货去向",
    "dispositionRequired": "有剩货一定要选择去向",
    "pickTarget": "请选择…",
    "targetOrder": "转到哪张出库单",
    "targetStore": "转到哪家店",
    "toLocPreview": "落点（预览）：{{loc}}",
    "backToWarehouseHint": "退物流仓只准未开箱整箱 —— 散件要选其他去向。",
    "note": "备注",
    "noteRequired": "原因（损坏注销必填）",
    "summary": "对数摘要",
    "summaryLines": "对得上：{{ok}}／{{total}} 行",
    "missingDisposition": "{{n}} 行未选去向",
    "draftHint": "草稿已存（未入账）—— 确认之后才出账并转「已结算」。",
    "saveDraft": "保存草稿",
    "confirm": "确认入账",
    "confirmHint": "确认 ＝ 一次性出账（卖出 SALE／剩货 TRANSFER／损坏 ADJUST），之后不能再改。",
    "confirmAsk": "确定确认入账 {{orderNo}}？（确认之后不能再改）",
    "needAllRows": "暂不能保存",
    "venue": "场地名称",
    "reportedAt": "场次日期",
    "movements": "结算产生的账目",
    "movementsEmpty": "还没有账目 —— 确认入账之后会列在这里（也可在库存账本查看）。",
    "movementSale": "售出（SALE）",
    "movementTransfer": "调拨（TRANSFER）",
    "movementAdjust": "更正（ADJUST）",
    "viewLedger": "去库存账本"
  },
  "weeklyFee": {
    "title": "每周仓租",
    "intro": "每周一结算物流仓租；计费基础是该周期初 cbm（整周照收、不按日计）。",
    "ratesTitle": "费率（后台设置）",
    "storageRate": "储存费（每 cbm／周）",
    "handlingRate": "入库手续费（每 cbm）",
    "settlementWeekday": "结算日（星期）",
    "weekdayMismatch": "⚠️ 设置的结算日不是星期一 —— 与期初制（逢周一）矛盾，请去设置页更正。",
    "currentWeek": "本周（{{week}}）",
    "openingCbm": "期初 cbm（计费基础）",
    "outboundCbm": "本周出库 cbm",
    "closingCbm": "期末 cbm",
    "storageAmount": "储存费",
    "handlingAmount": "手续费",
    "totalAmount": "合计",
    "issues": "完整性问题：",
    "generate": "产生／重算本周仓租",
    "generateHint": "只准星期一、不准未来周；已确认的周不准改（更正需另开调整记录）。",
    "regenerated": "已重算草稿 ✓",
    "generated": "已产生 ✓",
    "confirm": "确认入账",
    "confirmAsk": "确认之后金额不准再改（更正需另开调整记录），确定确认 {{week}} 这一周？",
    "confirmedOk": "已确认 ✓",
    "readOnlyHint": "（物流：你可以核对但不可以改数字 —— 有问题请在下面「确认」时写备注，或直接告诉职员）",
    "skuTitle": "逐个 SKU 的期初 cbm（核对用）",
    "skuHint": "加总 ＝ 上面「期初 cbm（计费基础）」；cbm 由箱尺寸自动计算（不靠人手估）。",
    "skuEmpty": "本周期初还没有货在仓。",
    "skuCode": "供应商",
    "skuName": "货品",
    "skuBarcode": "条码",
    "skuCartons": "箱",
    "skuCbm": "期初 cbm",
    "ack": "确认没问题",
    "ackAsk": "{{week}} 本周的 cbm 与价钱 —— 可以加备注（例：对得上／哪项有疑问）：",
    "ackOk": "已记录你的确认 ✓",
    "acksTitle": "确认记录",
    "acksHint": "每次确认都会留痕（谁、何时、备注）；⚠️ 这个动作**不会**改任何金额。",
    "acksEmpty": "还没有人确认过。",
    "historyTitle": "历史周费",
    "empty": "还没有已产生的周费。",
    "weekLabel": "{{start}} → {{end}}",
    "draft": "草稿",
    "confirmed": "已确认",
    "totals": "合计（已产生）"
  }
}
